/** MODULES MODALS */
export * from './add-cart/add-cart.module';
export * from './cancel-promo/cancel-promo.module';
export * from './cart-without-stock/cart-without-stock.module';
export * from './confirm-cancel/confirm-cancel.module';
export * from './continue-reset/continue-reset.module';
export * from './cooler-welcome/cooler-welcome.module';
export * from './daily-reward/daily-reward.module';
export * from './data-registers/data-registers.module';
export * from './delete-product-cart/delete-product-cart.module';
export * from './dynamic-promo/dynamic-promo.module';
export * from './favoritos-info-modal/favoritos-info-modal.module';
export * from './how-does-work/how-does-work.module';
export * from './info-sheet-modal/info-sheet-modal.page.module';
export * from './ladder-promo/ladder-promo.module';
export * from './leave-promo-detail/leave-promo-detail.module';
export * from './legal-change/legal-change.module';
export * from './lifeless/lifeless.module';
export * from './limit-counters/limit-counters.module';
export * from './max-discounts-limit/max-discounts-limit.module';
export * from './new-section-game/new-section-game.module';
export * from './order-progress/order-progress.module';
export * from './phone-register/phone-register.module';
export * from './promo-detail/promo-detail.module';
export * from './promo-info-modal/promo-info-modal.page.module';
export * from './promo-summary-modal/promo-summary-modal.page.module';
export * from './promotion/promotion.module';
export * from './purchase-progress/purchase-progress.module';
export * from './received-life/received-life.module';
export * from './reset-user/reset-user.module';
export * from './result-exe-push/result-exe-push.module';
export * from './reward-modal/reward-modal.page.module';
export * from './spam-cart/spam-cart.module';
export * from './spam-more-products/spam-more-products.module';
export * from './success-reset/success-reset.module';
export * from './timeout-edit/timeout-edit.module';
export * from './user-ticket/user-ticket.module';
export * from './zoom-image-fullscreen/zoom-image-fullscreen.module';

/** PAGE MODALS */
export * from './add-cart/add-cart.page';
export * from './cancel-promo/cancel-promo.page';
export * from './cart-without-stock/cart-without-stock.page';
export * from './confirm-cancel/confirm-cancel.page';
export * from './continue-reset/continue-reset.page';
export * from './cooler-welcome/cooler-welcome.page';
export * from './daily-reward/daily-reward.page';
export * from './data-registers/data-registers.page';
export * from './delete-product-cart/delete-product-cart.page';
export * from './dynamic-promo/dynamic-promo.page';
export * from './favoritos-info-modal/favoritos-info-modal.component';
export * from './how-does-work/how-does-work.page';
export * from './info-sheet-modal/info-sheet-modal.page';
export * from './ladder-promo/ladder-promo.page';
export * from './leave-promo-detail/leave-promo-detail.page';
export * from './legal-change/legal-change.page';
export * from './lifeless/lifeless.page';
export * from './limit-counters/limit-counters.page';
export * from './max-discounts-limit/max-discounts-limit.page';
export * from './new-section-game/new-section-game.page';
export * from './order-progress/order-progress.page';
export * from './phone-register/phone-register.page';
export * from './promo-detail/promo-detail.page';
export * from './promo-info-modal/promo-info-modal.page';
export * from './promo-summary-modal/promo-summary-modal.page';
export * from './promotion/promotion.page';
export * from './purchase-progress/purchase-progress.page';
export * from './received-life/received-life.page';
export * from './reset-user/reset-user.page';
export * from './result-exe-push/result-exe-push.page';
export * from './reward-modal/reward-modal.page';
export * from './spam-cart/spam-cart.page';
export * from './spam-more-products/spam-more-products.page';
export * from './success-reset/success-reset.page';
export * from './timeout-edit/timeout-edit.page';
export * from './user-ticket/user-ticket.page';
export * from './zoom-image-fullscreen/zoom-image-fullscreen.page';

